<script>
    import { faPlus } from "@fortawesome/free-solid-svg-icons";
    import {
        Dialog,
        DialogOverlay,
        DialogTitle,
        DialogDescription,
    } from "@rgossiaux/svelte-headlessui";
    import { createEventDispatcher } from "svelte";
    import Fa from "svelte-fa";
    import Button from "../ui/Button.svelte";
    import ButtonAdd from "../ui/ButtonAdd.svelte";
    import DateInput from "./DateInput.svelte";

    const dispatch = createEventDispatcher();

    let newSpecialDay;
    reset();

    function confirm() {
        if (!newSpecialDay.date || !newSpecialDay.date.match("^[0-3][0-9].[0-1][0-9].[0-9][0-9][0-9][0-9]$")) {
            return;
        }

        dispatch("add", {date: newSpecialDay.date.slice(3, 5) + newSpecialDay.date.slice(0, 2), year: newSpecialDay.annual ? "annual" : newSpecialDay.date.slice(6, 10), periods: newSpecialDay.periods});
        reset();
        open = false;
    }
    
    function reset() {
        newSpecialDay = {
            date: undefined,
            annual: false,
            periods: []
        };
    }

    function cancel() {
        open = false;
    }

    let open = false;
</script>

<Dialog class="dialog" open={open} on:close={cancel}>
    <DialogOverlay class="dialog-overlay"/>
    <div class="dialog-content">
        <DialogTitle class="dialog-title">Abweichende Öffnungszeiten</DialogTitle>
        <DialogDescription class="dialog-description">
            Lege abweichende Öffnungszeiten für einen bestimmten Tag fest. Du bestimmst, ob die Öffnungszeiten nur in diesem Jahr abweichen sollen, oder in Zukunft jedes Jahr.
        </DialogDescription>
        
        <form on:submit|preventDefault={confirm}>
            <DateInput 
                label="Datum"
                bind:value={newSpecialDay.date}
            />
            <label>
                <input type="checkbox" bind:checked={newSpecialDay.annual}>
                Jährlich wiederkehrend
            </label>
            
            <div class="dialog-options">
                <Button type="button" on:click={cancel}>
                    Abbrechen
                </Button>
                <Button type="submit" intent="primary">
                    Hinzufügen
                </Button>
            </div>
        </form>
    </div>
</Dialog>

<Button intent="primary" on:click={() => {open = true}}>
    <Fa icon={faPlus} slot="icon"/>
    hinzufügen
</Button>

<!-- <ButtonAdd on:click={() => {open = true}}>
    <Fa icon={faPlus} slot="icon"/>
</ButtonAdd> -->